import { createRoot } from 'react-dom/client';
import { initialize } from './app/store/init/actions';
import { Provider } from 'react-redux';
import TagManager from 'react-gtm-module';
import store from './app/store';
import App from './app/App';
import './polyfills';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './views/assets/scss/style.scss';
import '@mantine/core/styles.css';
import '@mantine/carousel/styles.css';
import { initGlobalErrorHandlers } from './utilites/initGlobalErrorHandlers';

TagManager.initialize({ gtmId: 'GTM-T9GV5C' });
TagManager.initialize({ gtmId: 'GTM-MTJBMKH' });

store.dispatch(initialize());

const container = document.getElementById('root');
const root = createRoot(container!);

initGlobalErrorHandlers();

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
